import { currencyDecimals, currencySymbol } from "./constants";

/** Format a numeric amount as a display price, e.g. `formatPrice(3.99)` → `"$3.99"`. */
export function formatPrice(value: number, decimals: number = currencyDecimals): string {
  return `${currencySymbol}${value.toFixed(decimals)}`;
}
